import Firebase from 'firebase';

import firebaseNode from '../firebase/firebaseNode';


class FirebaseService {
  constructor() {
    this.FirebaseMain = null;
  }

  initFirebase = (url, optionParameter) => {
    if (!optionParameter) {
      this.FirebaseMain = new Firebase(url);
    } else {
      this.FirebaseMain = new Firebase(url, optionParameter);
    }
  };

  _onAuthLog = (authData) => {
    if (authData) {
      // eslint-disable-next-line no-console
      console.warn('Authenticated to Firebase.', authData.auth);
    } else {
      // eslint-disable-next-line no-console
      console.warn('Firebase Client unauthenticated.');
    }
  };

  authWithCustomToken = (token) =>
    this.FirebaseMain.authWithCustomToken(token, (error) => {
      if (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    });

  watchThread = (rawRoomName, thread) => {
    const roomName = rawRoomName.toLowerCase();
    if (this.FirebaseMain) {
      switch (thread) {
        case 'roomStateRef':
          return this.FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/roomState`);
        case 'chatlessRoomUserCountRefLight':
          return this.FirebaseMain.child(`${firebaseNode.CHATLESS_ROOM_USER_COUNT_LIGHT}/${roomName}`);
        case 'broadcastingStatus':
          return this.FirebaseMain.child(`${firebaseNode.BROADCASTING_STATUS}/${roomName}`);
        case 'moderatorRef':
          return this.FirebaseMain.child(
            `${firebaseNode.CHAT_ROOMS}/${roomName}/${firebaseNode.FILTER_INFO}/moderatorUsers`
          );
        case 'silencedRef':
          return this.FirebaseMain.child(
            `${firebaseNode.CHAT_ROOMS}/${roomName}/${firebaseNode.FILTER_INFO}/silencedUsers`
          );
        case 'bannedRef':
          return this.FirebaseMain.child(
            `${firebaseNode.CHAT_ROOMS}/${roomName}/${firebaseNode.FILTER_INFO}/bannedUsers`
          );
        case 'userOfflineNotificationRef':
          return this.FirebaseMain.child(`${firebaseNode.USER_NOTIFICATION}/${roomName}`);
        case 'privateShowStatsRef':
          return this.FirebaseMain.child(`${firebaseNode.CHAT_ROOMS}/${roomName}/ps/br`);
        case 'privateShowRequests':
          return this.FirebaseMain.child(`${firebaseNode.PRIVATE_SHOW_REQUESTS}`).child(roomName);
        default:
          throw new Error(`${thread} doesn't exists.`);
      }
    }

    return undefined;
  };
}

export const FirebaseServiceClass = FirebaseService;

export default new FirebaseService();
